import { render, staticRenderFns } from "./Guias.vue?vue&type=template&id=55c4a676&scoped=true&"
import script from "./Guias.vue?vue&type=script&lang=js&"
export * from "./Guias.vue?vue&type=script&lang=js&"
import style0 from "./Guias.vue?vue&type=style&index=0&id=55c4a676&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c4a676",
  null
  
)

export default component.exports